import React, { Component } from 'react';
import TopBar from '../components/TopBar';
import LoggedUser from '../components/LoggedUser';
import './SecretarLayout.css';
import Menu from '../Menu';
import { Logout } from 'ra-ui-materialui';
import { Notification } from 'react-admin';

let left = 164;
if (window.location.hostname === 'secretar.me' || window.location.hostname === 'www.secretar.me' || window.location.hostname === 'secretar' || window.location.hostname === 'localhost') {
  left = 127;
}

class SecretarLayout extends Component {
  constructor(props) {
    super(props);
    this.state = { logged: true };
  }

  render() {
    const { children } = this.props;
    const { logged } = this.state;

    const logout = <Logout translate={() => 'Выход'} />;
    return (
      <div>
        <div className="appbar-top">
          <TopBar
            userComponent={logged ? <LoggedUser logout={logout} /> : null}
          />
        </div>
        <div className="appbar-menu-top" style={{left:left}}>
          <Menu />
        </div>
        <div style={{ marginTop: '40px' }}>{children}</div>
        <Notification translate={(message) => message} />
      </div>
    );
  }
}

export default SecretarLayout;



// WEBPACK FOOTER //
// ./src/stylization/SecretarLayout.js